import { forEach, some, reduce, isString, isObject, has } from 'lodash';
import { mapState, mapActions } from 'vuex';
import { DISABLED_VALUE, SELF_DISABLED_VALUE, TRIGGER_TYPE_QUESTION_TIP } from '../../../constants';
import { expresionResolvr } from '../../common/helpers';
import { rulesMutatorApplicator } from '../../vuex/RulesMutatorApplicator';

const questionMixin = {

    props: {
        questionIndex: Number,
        uukey: String,
        uuid: Number,
        title: String,
        subTitle: {
            type: String,
            default: '',
        },
        choices: Array,
        values: null,
        hashelp: Boolean,
        triggers: Object,
        mutators: Array,
        otherEnabled: [Boolean, String],
        otherInstructions: {
            type: [String, Boolean],
            default: false,
        },
        selfDisablable: {
            type: [String, Boolean],
            default: false,
        },
        readOnly: Boolean,
    },

    data()
    {
        return {
            mounted: false,
            othervalue: null,
            questionTip: false,
        }
    },

    created()
    {
        // Initialize state in store:
        this.$store.commit('INIT_ANSWER', [this.uukey, this.uuid, this.values]);

        if (has(this.values, 'other'))
        {
            this.othervalue = this.values.other;
        }
        rulesMutatorApplicator.addRule(this.mutators);
    },

    beforeMount()
    {
        forEach(this.triggers, (rules, key) =>
        {
            switch(key)
            {
                case TRIGGER_TYPE_QUESTION_TIP:
                    this.questionTipTriggerWatch(rules);
                    break;
                default:
                    break;
            }
        });
    },

    mounted()
    {
        this.mounted = true;
    },

    computed: {

        otherLabel()
        {
            if (this.otherEnabled === false)
            {
                return null;
            }
            if (isString(this.otherEnabled))
            {
                return this.otherEnabled;
            }
            return 'Autres :';
        },

        disabled()
        {
            if (has(this.answer), 'answer')
            {
                return (this.answer.answer == DISABLED_VALUE || this.answer.answer == SELF_DISABLED_VALUE);
            }
            return false;
        },

        ...mapState({
            answer(state)
            {
                return state.answers[this.uukey];
            },
        }),
    },

    methods: {

        questionTipTriggerWatch(rules)
        {
            this.$watch('answer', (newVal) =>
            {
                this.questionTip = reduce(rules, (accumulator, value, exprss) =>
                {
                    if (accumulator === false)
                    {
                        if (expresionResolvr(exprss, newVal.answer))
                        {
                            return value;
                        }
                    }
                    return accumulator;
                }, false);
            }, {immediate: true});
        },

        setSelfDisabled(state)
        {
            this.dispatchChangeAnswer([this.uukey, state])
        },

        ...mapActions({
          dispatchChangeAnswer: 'CHANGE_ANSWER',
        }),
    },
};

export { questionMixin }



// WEBPACK FOOTER //
// ./resources/assets/js/components/vue/mixins/question-mixin.js